import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { PatientReminderItem } from "../PatientReminder/PatientReminderItem";
import { t } from "i18next";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
var ReminderList = function ReminderList(_ref) {
  var data = _ref.data,
    patient_uid = _ref.patient_uid,
    onEditReminder = _ref.onEditReminder,
    onAddNewReminder = _ref.onAddNewReminder,
    refetchReminders = _ref.refetchReminders,
    onBackToSummary = _ref.onBackToSummary,
    workspaceId = _ref.workspaceId;
  // Sort reminders: unresolved first, resolved at the end
  var sortedData = _toConsumableArray(data).sort(function (a, b) {
    var aResolved = a.resolved ? 1 : 0;
    var bResolved = b.resolved ? 1 : 0;
    return aResolved - bResolved;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden bg-white text-gray-800 dark:bg-gray-800 dark:text-gray-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-5 py-[7px] dark:bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onBackToSummary,
    className: "hover:bg-gray-100 dark:hover:bg-gray-700 -ml-2 px-2 rounded transition-colors cursor-pointer"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    size: "sm",
    className: "text-gray-800 dark:text-gray-200"
  })), /*#__PURE__*/React.createElement("span", {
    className: "flex-1 ml-3 font-medium text-base"
  }, t("key.tasks"))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col grow h-[1px] p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grow h-[1px] overflow-y-auto scrollbar-light dark:scrollbar"
  }, sortedData.map(function (reminder) {
    return /*#__PURE__*/React.createElement(PatientReminderItem, {
      key: reminder.id,
      reminder: reminder,
      patient_uid: patient_uid,
      showReminderEditModal: function showReminderEditModal(reminder) {
        onEditReminder(reminder);
      },
      refetchReminders: refetchReminders,
      workspaceId: workspaceId
    });
  })), /*#__PURE__*/React.createElement("button", {
    className: "w-full flex items-center justify-center bg-teal-600 hover:bg-teal-700 dark:bg-transparent dark:hover:bg-teal-600 gap-2 border-2 border-teal-600 dark:border-teal-600 text-white text-[14px] rounded-md transition-colors mt-4 flex-shrink-0 p-[24px]",
    onClick: onAddNewReminder
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[16px]"
  }, "+"), " ", t("label.add_new"))));
};
export default ReminderList;